import { loadAndMigrateState, Migrator, migrateProduktForVorteilsrabatt } from '@ps20-frontend/migrations';
import { IAppState } from '../appState';
import { migrateKooperationsNachlass } from './7_migrate_kooperations-nachlass';

export const stateMigrators: Migrator[] = [
  {
    toVersion: 7,
    migratorFunction: migrateKooperationsNachlass,
  },
  {
    toVersion: 8,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
  {
    toVersion: 9,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
  {
    toVersion: 10,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
];

export const loadAndMigrateRsState = (
  currentState: IAppState,
  loadedState: { version: number },
  beibehalten?: boolean,
) => loadAndMigrateState(currentState, loadedState, stateMigrators, beibehalten);
